/* eslint-disable no-console */

const getEnvFlag = (key: string): string | undefined => {
  return (import.meta?.env as Record<string, string | undefined>)?.[key];
};

/**
 * Checks whether reporting/logging on the console is enabled via environment variables.
 * Key used: VITE_ENABLE_CONSOLE (or VITE_ENABLE_CONSOLE_REPORTING / VITE_ENABLE_LOGS).
 * Defaults to true if not specified.
 */
export const isConsoleEnabled = (): boolean => {
  const envVal =
    getEnvFlag('VITE_ENABLE_CONSOLE') ??
    getEnvFlag('VITE_ENABLE_CONSOLE_REPORTING') ??
    getEnvFlag('VITE_ENABLE_LOGS');

  if (envVal === undefined || envVal === null || envVal === '') {
    return true;
  }

  const normalized = String(envVal).trim().toLowerCase();
  return normalized !== 'false' && normalized !== '0' && normalized !== 'off';
};

/**
 * References to original console methods.
 */
export const originalConsole = {
  log: console.log,
  info: console.info,
  warn: console.warn,
  error: console.error,
  debug: console.debug,
  table: console.table,
  group: console.group,
  groupCollapsed: console.groupCollapsed,
  groupEnd: console.groupEnd,
};

/**
 * Initializes console reporting status.
 * If console reporting is disabled via VITE_ENABLE_CONSOLE=false in .env,
 * console functions are overridden with no-op functions.
 */
export const initConsoleReporting = (): void => {
  if (!isConsoleEnabled()) {
    const noop = () => {};
    console.log = noop;
    console.info = noop;
    console.warn = noop;
    console.error = noop;
    console.debug = noop;
    console.table = noop;
    console.group = noop;
    console.groupCollapsed = noop;
    console.groupEnd = noop;
  }
};
